<template>
  <div>
    
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto my-auto  bg-color--light--1    ">
            <h3 class="text-center pt-6">خلاصه وضعیت قرارداد</h3>
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :line-numbers="true"
              :rtl="true"
               @on-row-click="onRowClick"
              row-style-class="rowStyleClassFn"
              class="mt-5  pb-10 mr-0 ml-0 px-2 pt-3"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'status'">
                  <span v-html="statusFn(props.row.status)"> </span>
                </span>
                <span v-else-if="props.column.field == 'instalment_start_date'">
                  {{
                    props.row.instalment_start_date | moment("jYYYY/jMM/jD ")
                  }}</span
                >
                <span v-else-if="props.column.field == 'end_date'">
                  {{ props.row.end_date | moment("jYYYY/jMM/jD") }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
                <span v-if="props.column.field == 'btn'">
                  <span v-html="actionBtn(props.row.originalIndex)"> </span>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      
</template>

<script>
// import HeaderSuplier from "../components/shared/HeaderSuplier";

export default {
  components: {},
  data() {
    return {
      columns: [
          // supplier_name
        {
          label: "آیدی",
          field: "id",
          hidden:true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        // supplier_name
        {
          label: "نام فروشگاه",
          field: "supplier_name",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // net_amount
        {
          label: " مبلغ فاکتور",
          field: "net_amount",
          type: "number",

          tdClass: "text-center",
          thClass: "text-center",
        },
        // downpayment
        {
          label: " پیش پرداخت",
          field: "downpayment",
          type: "number",

          tdClass: "text-center",
          thClass: "text-center",
        },
        // number_of_instalment
        {
          label: "تعداد اقساط",
          field: "number_of_instalment",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // instalment_amount
        {
          label: "مبلغ هر قسط",
          field: "instalment_amount",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // total_amount_of_instalments
        {
          label: "مجموع اقساط",
          field: "total_amount_of_instalments",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // instalment_start_date
        {
          label: "تاریخ شروع اقساط",
          field: "instalment_start_date",
          //   type: "date",
          html: true,
          tdClass: "text-center",
          thClass: "text-center",
          //   dateInputFormat: "yyyy-MM-dd",
          //   dateOutputFormat: "MMM Do yy",
        },
        // end_date
        {
          label: "تاریخ پایان قرارداد",
          field: "end_date",
          //   type: "date",
          tdClass: "text-center",
          thClass: "text-center",
          //   dateInputFormat: "yyyy-MM-dd",
          //   dateOutputFormat: "MMM Do yy",
        },
        // remaining_amount
        {
          label: "مبلغ کل باقی مانده",
          field: "remaining_amount",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // debit_amount
        {
          label: "میران بدهی تا این لحظه",
          field: "debit_amount",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // number_of_pays
        {
          label: "تعداد اقساط پرداخت شده",
          field: "number_of_pays",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // status
        {
          label: " وضعیت قراداد",
          field: "status",
          type: "string",
          tdClass: "text-center",
          thClass: "text-center",
          // width: "80px"
          // filterable: true,
          // filterOptions: {
          // 	enabled: true, // enable filter for this column
          // 	placeholder: "جست و جو وضعیت", // placeholder for filter input
          // 	filterDropdownItems: [
          // 		{ value: "pass", text: "تایید" },
          // 		{ value: "failed", text: "رد" },
          // 		{ value: "awaiting", text: "در انتظار" }
          // 	],
          // 	trigger: "" //only trigger on enter not on keyup
          // }
        },
        // vcc_number
        {
          label: "شماره کارت",
          field: "vcc_number",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // btn
        {
          label: "جزییات",
          field: "btn",
          html: true,
          hidden:true,
          thClass: "text-center",
        },
      ],
      rows: [],
    };
  },
  mounted() {
    this.getContracts();
  },
  methods: {
    statusFn: function(st) {
      if (st === "0") {
        return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>تایید نشده</b></span>';
      }
      if (st === "1") {
        return '<span class="badge badge-info" style="height:25px;"><b>در حال عقد قراداد</b></span>';
      }
      if (st === "2") {
        return '<span class="badge badge-success" style="height:25px;"><b> تایید قرارداد و ارسال کالا</b></span>';
      }
      if (st === "3") {
        return '<span class="badge badge-info" style="height:25px;text-align:center"><b>تسویه با فروشگاه</b></span>';
      }
      if (st === "4") {
        return '<span class="badge badge-info" style="height:25px;"><b>پرداخت اقساط</b></span>';
      }
      if (st === "5") {
        return '<span class="badge badge-success" style="height:25px;"><b> تصفیه نهایی</b></span>';
      }
      if (st === "6") {
        return '<span class="badge badge-warning" style="height:25px;"><b> تحویل مدارک به متقاضی</b></span>';
      }
      if (st === "7") {
        return '<span class="badge badge-danger" style="height:25px;"><b>انصراف متقاضی</b></span>';
      }
      return;
    },
    actionBtn: function() {
      return '<button  @click.prevent="showContractDetail" type="button" class="btn btn-primary text-center font-w--400 " style="width:70px;height:35px;font-size: 0.75rem;">جزییات</button>';
    },
    // eslint-disable-next-line no-unused-vars

    getContracts() {
      let load=this.$loading.show()
      this.$store
        .dispatch("getContracts")
        .then((resp) => {
          console.log(resp);
          this.rows = resp.body;
          load.hide()
        })
        .catch((err) => {
          console.log(err);
          load.hide()
        });
    },
    showContractDetail(id){
        console.log("id= ",id)
    },
      onRowClick(params) {
     
          this.$router.push("/customer/contract-detail/"+params.row.id)
     
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  }
  },

  computed: {},
};
</script>

<style>
.green {
  background-color: green;
}

.red {
  background-color: red;
}
</style>
